<template>
    <div class=''>
        <loading ref="loading"></loading>
        <b-modal body-class='dialog-body-noscroll' centered ref="searchDialog" :title="title" size="lg">

            <div>
                <autocomplete ref='auto' class="form-control col-18"
                        :source="source"
                        results-property="data"
                        results-value="id"
                        @selected='(obj) => {item = obj.selectedObject}'
                        @clear='item = {}'
                        
                        :request-headers="authHeaders"
                        >
                        <!-- :results-display="formattedUserDisplay" -->
                    </autocomplete>
                <template v-if='item && item.id'>
                    <div v-if='item.id == self.id' class="alert alert-warning mt-2" role="alert">
                        {{selfMessage}}
                    </div>
                    <div v-if='existing.find(obj => {return obj[existingIdField] == item.id})' class="alert alert-warning mt-2" role="alert">
                        {{existsMessage}}
                    </div>
                </template>
            </div>
            <!-- <img :width='full_image.width' :height='full_image.height' style='max-width: 100%; max-height: 100%;' :src='full_image.data'> -->
            <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-left" variant="primary" v-on:click.prevent='$refs.searchDialog.hide()'>
                    {{$t('translations.close')}}
                </b-btn>
                
                <b-btn v-if='item && item.id && item.id != self.id && !existing.find(obj => {return obj[existingIdField] == item.id})' size="sm" class="float-right mr-1 btn-success" variant="primary" v-on:click.prevent='select'>
                    {{$t('translations.okay')}}
                </b-btn>

                
            </div>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: {
            title: {
                default: "Search"
            },
            source: {

            },
            existing: {
                default: []
            },
            self: {
                default: {id: null}
            },
            selfMessage: {
                default: Vue.i18n.translate('translations.search_cant_select')
            },
            existsMessage: {
                default: Vue.i18n.translate('translations.search_item_already_exists')
            },
            existingIdField: {
                default: "id"
            }


            
		},
		data: function(){
			return {
                item: {}
			};
		},
		computed: {
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
		},
		mounted() {

        },
        watch: {

        },
		methods: {
            show(user) {
                this.item = {}
                this.errors = [];
                this.$refs.searchDialog.show();
                Vue.nextTick(() => {
                    this.$refs.auto.clear();
                })
            },
            select() {
                this.$refs.searchDialog.hide();
                this.$emit("selected", this.item);
            },
            formattedUserDisplformattedUserDisplay (result) {
                if(result) {
                    return this.formatNameCompliant(result) 
                        + (result.dob ? " | " + this.formatDate(result.dob) : "")
                        + (result.gender ? " | " + this.getGender(result.gender) : "")
                        + (result.nhs_number ? " | " + result.nhs_number.replace(/(.{3})/,"$1 ").replace(/(.{7})/,"$1 ") : "");
                }
                return '';
            },
           
		}
    }
</script>
